import { cn } from '@helpers/cn';
import { ButtonHTMLAttributes } from 'react';

export const MenuItemButton = ({ className, children, ...props }: ButtonHTMLAttributes<HTMLButtonElement>) => (
  <li>
    <button
      type="button"
      className={cn(
        'flex w-full items-center gap-2.5 whitespace-nowrap bg-transparent px-4 py-2.5 text-left text-sm font-medium text-foreground-muted hover:bg-surface-muted hover:text-accent [&_svg]:size-5 [&_svg]:shrink-0',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  </li>
);
